import { i18n } from '@/i18n'
export default [
  {
    path: 'notifications/notices/error',
    name: 'notifications/notices/error',
    component: () => import('@/views/notifications/Notifications.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'error', title: i18n.t('app.noticesError') }
  },
  {
    path: 'notifications/notices/sindescarga',
    name: 'notifications/notices/sindescarga',
    component: () => import('@/views/notifications/Notifications.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'sinDescarga', title: i18n.t('app.noticesSinDescarga') }
  },
  {
    path: 'notifications/notices/fintramite',
    name: 'notifications/notices/fintramite',
    component: () => import('@/views/notifications/Notifications.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'finTramite', title: i18n.t('app.noticesFinTramite') }
  },
  {
    path: 'notices/certificadoscaducar',
    name: 'notices/certificadoscaducar',
    component: () => import('@/views/certificates/Certificates.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'certificadoscaducar', title: i18n.t('app.noticesCertsCaduc') }
  },
  {
    path: 'notices/certificadoscaducados',
    name: 'notices/certificadoscaducados',
    component: () => import('@/views/certificates/Certificates.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'certificadoscaducados', title: i18n.t('app.noticesCertsCaducados') }
  },
  {
    path: 'notices/usuariospasswordcaducar',
    name: 'notices/usuariospasswordcaducar',
    component: () => import('@/views/configuration/Users.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'usuariospasswordcaducar', title: i18n.t('app.usuariospasswordcaducar') }
  }
]
